import { Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { ApprovedIcon } from '../Icons/Approved';
import { NotApplicableIcon } from '../Icons/NotApplicable';
import { RejectedIcon } from '../Icons/Rejected';
import { WarningIcon } from '../Icons/Warning';
import { JobExecutionStatus } from 'models/jobs/shared';
export const useJobSectionTitleStyles = () => {
    const { tokens } = useContext(ThemeContext).theme;
    return {
        fontSize: tokens.text.size.medium,
        marginTop: tokens.spacing.xlarge,
        marginBottom: tokens.spacing.default,
        fontWeight: tokens.text.weight.semiBold
    };
};
export const useTableStyles = () => {
    const { tokens } = useContext(ThemeContext).theme;
    return {
        captionStyles: {
            padding: tokens.spacing.xsmall,
            fontWeight: tokens.text.weight.bold
        },
        tableStyles: {
            border: `1px solid ${tokens.colors.gray100}`,
            borderCollapse: 'collapse',
            width: '80%',
            margin: `${tokens.spacing.large} 0`
        },
        thStyles: {
            border: `1px solid ${tokens.colors.gray100}`,
            padding: tokens.spacing.xsmall,
            fontWeight: tokens.text.weight.bold,
            color: tokens.colors.white,
            backgroundColor: tokens.colors.purple,
            textAlign: 'left'
        },
        tdStyles: {
            border: `1px solid ${tokens.colors.gray100}`,
            padding: tokens.spacing.xsmall
        },
        trStyles: {
            backgroundColor: tokens.colors.gray50
        }
    };
};
export const dropdownWrapperStyle = {
    margin: '0 auto 0 0',
    width: ['100%', '70%']
};
export const DropdownStatusIcon = ({ parentJobStatus, jobStatus, dropdownHasRejections, dropdownHasWarnings }) => {
    if (jobStatus === JobExecutionStatus.Error) {
        return React.createElement(WarningIcon, { error: true });
    }
    if (parentJobStatus === 'approved' || parentJobStatus === 'rejected') {
        if (dropdownHasRejections) {
            return React.createElement(RejectedIcon, null);
        }
        if (dropdownHasWarnings) {
            return React.createElement(WarningIcon, null);
        }
        return React.createElement(ApprovedIcon, null);
    }
    return null;
};
export var DropdownItemTypes;
(function (DropdownItemTypes) {
    DropdownItemTypes["BooleanDropdownItem"] = "BooleanDropdownItem";
    DropdownItemTypes["ConfidenceDropdownItem"] = "ConfidenceDropdownItem";
})(DropdownItemTypes || (DropdownItemTypes = {}));
export const addIconsToDropdownItems = (dropdownItems) => {
    let dropdownHasRejections = false;
    let dropdownHasWarnings = false;
    const dropdownItemsWithIcons = dropdownItems.map((item) => {
        const { hasError, hasWarning } = item.hasErrorOrWarning;
        dropdownHasRejections ||= hasError;
        dropdownHasWarnings ||= hasWarning;
        if (hasError) {
            return {
                ...item,
                statusIcon: React.createElement(RejectedIcon, null)
            };
        }
        if (hasWarning) {
            return {
                ...item,
                statusIcon: React.createElement(WarningIcon, null)
            };
        }
        if (item.type === DropdownItemTypes.BooleanDropdownItem) {
            dropdownHasRejections ||= item.value === false;
            return {
                ...item,
                statusIcon: React.createElement(BooleanItemIcon, { value: item.value })
            };
        }
        return {
            ...item,
            statusIcon: item.available ? React.createElement(ApprovedIcon, null) : React.createElement(NotApplicableIcon, null)
        };
    });
    return {
        dropdownItems: dropdownItemsWithIcons,
        dropdownHasRejections,
        dropdownHasWarnings
    };
};
const BooleanItemIcon = ({ value }) => {
    if (value === true) {
        return React.createElement(ApprovedIcon, null);
    }
    if (value === false) {
        return React.createElement(RejectedIcon, null);
    }
    return React.createElement(NotApplicableIcon, null);
};
export const readableBoolean = (bool) => {
    if (bool === undefined) {
        return '';
    }
    return bool ? 'True' : 'False';
};
export const readableString = (str) => {
    if (str === null || str === undefined) {
        return '';
    }
    return str;
};
export const readableNumber = (num) => {
    if (num === null || num === undefined) {
        return '';
    }
    return String(num);
};
export const JobErrorMessage = ({ typeName }) => {
    return (React.createElement(Text, null,
        typeName,
        " could not be completed. Please try again or contact support."));
};
export const camelCaseToTitleCase = (camelCaseString) => {
    if (!camelCaseString) {
        return '';
    }
    const spacedString = camelCaseString.trim().replaceAll(/([A-Z])/g, ' $1');
    const titleCasedString = spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
    return titleCasedString;
};
